import axios from "axios";
import { getGatewayBaseUrl } from "src/lib/public-api-host";

const $api = axios.create({
  baseURL: getGatewayBaseUrl(),
  headers: {
    "Content-type": "application/json",
  },
});
// Leftover marketplace client. Never attach a Firebase ID token or bounce the cabinet on 401.

$api.interceptors.request.use((config) => {
  config.baseURL = getGatewayBaseUrl();
  return config;
});

export default $api;
